// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__VWYHI","header":"ReportDetails_header__3HF5g","title":"ReportDetails_title__3FeSL","left":"ReportDetails_left__d1nvT"};